import { Base } from '@studiometa/js-toolkit';

/**
 * Ressources class.
 */
export default class CategoriesDropdown extends Base {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'CategoriesDropdown',
    refs: ['dropdown', 'select', 'selected'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.dropdownActive = false;
  }

  /**
   * On click show or hide dropdown
   * @returns {void}
   */
  onSelectClick() {
    if (this.dropdownActive) {
      this.hideDropdown();
    } else {
      this.showDropdown();
    }
  }

  /**
   * Hide dropdown when click outside it
   * @param  {object} e
   * @returns {void}
   */
  clickOutside(e) {
    if (e.target !== this.$refs.dropdown && e.currentTarget !== this.$refs.select)
      this.hideDropdown();
  }

  /**
   * Display dropdown
   * @returns {void}
   */
  showDropdown() {
    this.dropdownActive = true;
    this.$refs.select.classList.add('open');
    setTimeout(() => {
      document.addEventListener('click', this.clickOutside.bind(this), { once: true });
    }, 500);
  }

  /**
   * Hide dropdown
   * @returns {void}
   */
  hideDropdown() {
    this.$refs.select.classList.remove('open');
    this.dropdownActive = false;
    document.removeEventListener('click', this.clickOutside);
  }
}
